/** @jsx jsx */
import { jsx } from '@emotion/core';

import { useState, Fragment, useEffect } from 'react';
import { SiteLink } from '../../components';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { NavBar } from './navBar';
import { BackButton } from '../backButton/backButton';
import { Hamburger } from '../hamburger/hamburger';
import style from './topHeaderStyle';
import { NavBarHori } from "./navBarHori";
import { isMax } from '../../lib/css-emotion/breakpoints';

export function TopHeader(props) {
  const [menuOpened, setMenuOpened] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showNavBarHori, setShowNavBarHori] = useState(true);

  useEffect(() => {
    // inital check
    checkScreenSize();

    // add window size change listener
    window.addEventListener('resize', checkScreenSize);

    // remove window size change listener when component unmount
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  function checkScreenSize() {
    // if screen size is less than 1200px (xl breakpoint), then hide NavBarHori
    setShowNavBarHori(!isMax.xl());
  }

  useScrollPosition(({ prevPos, currPos }) => {
    //console.log(currPos.x)
    //console.log(currPos.y);
    if (currPos.y > 90) {
      setScrolled(true)
    } else {
      setScrolled(false)
    }
    //setScrolled(currPos.y > 90)
  }, [], null, true)

  function toggleMenu(e) {
    setMenuOpened(!menuOpened);
  }

  function closeMenu() {
    setMenuOpened(false);
  }

  return (
    <Fragment>
      <header css={[style.top, scrolled && style.topScrolled]} id="top">
        <BackButton />
        <div css={style.topHeaderContainerWrapper}>
          <div css={style.topHeaderContainer}>
            <SiteLink to="/" css={[style.logo, scrolled && style.logoScrolled]}>
              <img css={[style.logoImg, scrolled && style.logoImgScrolled]} src="/assets/logos/logo.png" alt="logo" />
            </SiteLink >
          </div>
          <div css={style.topHeaderContainerRight}
            style={{ justifyContent: showNavBarHori ? 'space-between' : 'end' }}>
            {showNavBarHori && <NavBarHori css={style.navBarHori} />}
            <Hamburger opened={menuOpened} toggleMenu={toggleMenu} scrolled={scrolled} />
          </div>
        </div>
        <NavBar open={menuOpened} onCloseMenu={closeMenu}></NavBar>
        {/* <CartButton /> */}
      </header>
    </Fragment>
  );
}